export class Codification {
    constructor(
        public type: string = "numbers",
        public image: string = null,
        public size: number = 10,
    ) {

    }
    public static fromData(data) {
        if (!data) return;
        let c = new Codification(
            data.type,
            data.image,
            data.size
        )
        return c;
    }

    public get digits() {

        return new Array(this.size);
    }
}